import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FilesService } from 'src/app/services/api/files.service';
import { WinService } from 'src/app/services/win.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-election-t-shirt',
  templateUrl: './election-t-shirt.component.html',
  styleUrls: ['./election-t-shirt.component.scss']
})
export class ElectionTShirtComponent implements OnInit {

	env = environment;
	inquiryForm: FormGroup;

	files:any = [];
	fileUploadError:string = '';
	config: any = null;

	sending:boolean = false
	sendingProgress:any = 0;
	xhr:XMLHttpRequest = null;
	formApiResponseErrors:any = null;

	constructor(
		public winService: WinService,
		private formBuilder: FormBuilder,
		public filesService: FilesService
	) {
		this.filesService.get('/rest/entrelable/V1/lns-orderattachment/config').subscribe(config => {
			this.config = config[0];
		});
	}

	ngOnInit(): void {
		this.inquiryForm = this.formBuilder.group({
			name: [""],
			email: [""],
			mobile_number: [""],
			remarks: [""],
			attachments: [""],
			qty: [""],
			print_location: [""],
		});
	}

	prepareFile(event){

		this.files = [];
		let files = event.target.files;

		for (let index = 0; index < files.length; index++) {
			let file = files[index];
			this.files.push(file);
		}


		// this.files = [];
		// this.fileUploadError = '';

		// let files = event.target.files;
		// let totalTotalSize = 0;
		// let maxFileSize = 1024 * 1024 * 25;
		// let maxFileSizeReadable = this.filesService.humanFileSize(maxFileSize, true);

		// let fileErrors = [];
		// for (let index = 0; index < files.length; index++) {
		// 	let file = files[index];

		// 	/** 
		// 	 * 25 mb is the maximung file size can be attached in email 
		// 	 * ref https://support.google.com/mail/answer/6584?hl=en&co=GENIE.Platform%3DDesktop#zippy=%2Cattachment-size-limit
		// 	 */
		// 	if(file.size <= maxFileSize){ 
		// 		let fName = file.name;
		// 		let ext = fName.split('.');
		// 		ext = ext[ext.length - 1];
		// 		ext = ext.toLowerCase();


		// 		if(this.config.accepted_file_type[ext]){
		// 			this.files.push(file);
		// 			totalTotalSize += file.size;
		// 		} else {
		// 			this.files = [];

		// 			let types: any = [];
		// 			for (var key in this.config.accepted_file_type) {
		// 			    if (this.config.accepted_file_type.hasOwnProperty(key)) {
		// 			        types.push(key);
		// 			    }
		// 			}
		// 			types = types.join(', ');
		// 			this.fileUploadError = 'Please upload ' + types + ' only';
		// 		}
		// 	}
		// 	else {
		// 		this.fileUploadError = 'The maximum file size should be ' + maxFileSizeReadable;
		// 		this.files = [];
		// 		totalTotalSize = 0;
		// 	}

		// 	fileErrors.push(file.name + ' ' + this.filesService.humanFileSize(file.size, true));
		// }

		// if(totalTotalSize > maxFileSize){
		// 	this.fileUploadError = 'The maximum file size should be ' + maxFileSizeReadable;
		// 	if(fileErrors.length){
		// 		this.fileUploadError += '<br />' + fileErrors.join('<br />');
		// 	}
		// 	this.files = [];
		// }
	}

	get getSendingProgress() {
		return this.sendingProgress.toFixed(2);
	}

	sendMessage(){
		let formData = new FormData();
		formData.append('name', this.inquiryForm.value.name);
		formData.append('email', this.inquiryForm.value.email);
		formData.append('mobile_number', this.inquiryForm.value.mobile_number);
		formData.append('remarks', this.inquiryForm.value.remarks);
		formData.append('qty', this.inquiryForm.value.qty);
		formData.append('print_location', this.inquiryForm.value.print_location);

		if(this.files.length){
			this.files.forEach(file => {
				formData.append('attachments[]', file);
			});
		}
		
		this.formApiResponseErrors = {};
		this.sending = true;

		let url = this.filesService.getUrl(this.filesService.getStoreUrl('/V1/lns-entrelabel/t-shirt/election-t-shirt/inquiry'));
		this.filesService.ajax({
			method: 'POST',
			url: url,
			data: formData,
			error: error => {
				
			},
			success: response => {
				this.sendMessageAfter(response);
			},
			complete: complete => {
				this.files = [];
				this.sending = false;
				this.sendingProgress = 0;
			},
			uploadProgress: (e, uploadProgress) => {
				this.sendingProgress = uploadProgress;
			},
			abort: (xhr) => {
				this.xhr = xhr;	
			}
		});
	}

	sendMessageAfter(response){
		let resp = response[0];

		if(!resp['error']){
			this.inquiryForm.reset();
			this.inquiryForm.markAsUntouched();

			this.filesService.toastService.add(resp.message, 'success');
		}
		else {
			if(typeof resp.message == 'string'){
				this.filesService.toastService.add(resp.message, 'danger');
			}
			else {
				this.formApiResponseErrors = resp.message;
				this.filesService.toastService.add('One or more errors were encountered while sending the message.', 'danger');
			}
		}
	}

	abortSendMessage(){
		this.xhr.abort();
		this.sendingProgress = 0;
		this.sending = false;
	}

}
